import {
  CalculatorIcon,
  ChatBubbleBottomCenterIcon,
  ChatBubbleBottomCenterTextIcon,
  RectangleGroupIcon,
  UserGroupIcon,
  UsersIcon,
} from "@heroicons/react/24/outline"

import { StatCardCompact } from "@components"
import PropTypes from "prop-types"

const Stats = ({ summary = {} }) => {
  const {
    parent_total = 0,
    read_total = 0,
    no_of_groups = 0,
    staff_total = 0,
    total = 0,
    unread_total = 0,
  } = summary?.data?.reportCommentsSummary || {}

  return (
    <div className="grid grid-cols-1 gap-5 my-5 sm:grid-cols-3 2xl:grid-cols-6">
      <StatCardCompact
        title="Total"
        stat={total}
        icon={<CalculatorIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Staff"
        stat={staff_total}
        icon={<UserGroupIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Parents"
        stat={parent_total}
        icon={<UsersIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Read"
        stat={read_total}
        icon={<ChatBubbleBottomCenterTextIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="Unread"
        stat={unread_total}
        icon={<ChatBubbleBottomCenterIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />

      <StatCardCompact
        title="No of Groups"
        stat={no_of_groups}
        icon={<RectangleGroupIcon className="w-10 h-10 text-white" aria-hidden="true" />}
      />
    </div>
  )
}

Stats.propTypes = {
  summary: PropTypes.object,
}

export default Stats
